module.exports = __webpack_public_path__ + "static/media/ice_pellets_light.70776496.svg";